import styled from 'styled-components';
import { Badge } from '@prisjakt/ui/badge';
import { layout, media } from '@prisjakt/ui-base';

export const StyledBadge = styled(Badge)`
  ${media.largeOnly`
    margin-right: ${layout.measurements.spacing025};
  `}
`;
